import { ref } from 'vue';

const DEFAULT_SHOW_SIDE_TABLE = false;

// Factory for creating instance-scoped side table state
export function createSideTable(options?: { showSideTable?: boolean }) {
  const showSideTable = ref(options?.showSideTable ?? DEFAULT_SHOW_SIDE_TABLE);

  function toggleSideTable() {
    showSideTable.value = !showSideTable.value;
  }

  function setShowSideTable(value: boolean) {
    showSideTable.value = value;
  }

  return { showSideTable, toggleSideTable, setShowSideTable };
}

export {
  DEFAULT_SHOW_SIDE_TABLE
};
